import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../../Styles/LessonPreview.css'

const LessonPreview = () => {
    const location = useLocation();
    const { topic, fileName, pdfFile, videoName, videoFile, text } = location.state || {};
    const [isConfirm, setIsConfirm] = useState(false)
    const [editModal, setModal] = useState(false)

    const editHandle = () => {
        setModal(x => !x)
    }

    const handleCon = () => {
        setIsConfirm(true)
    }

    // const { topic, fileName, videoFile, text } = state; // video faylni ham uzatamiz


    return (
        <div className='preview'>
            <p className="edited-text">Tahrirlash</p>
            <div className="preview-block">
                <p className="lesson-number">1-dars</p>
                <h3 className="prewiew-name">{topic}</h3>
                <div className="preview-video">
                    <video controls className='preview-vid'>
                        <source src={URL.createObjectURL(videoFile)} type={videoFile.type} />
                        Your browser does not support the video tag.
                    </video>
                    <div className="preview-video-right">
                        <h3 className="preview-materials-name">Darsga oid yozma materiallar:</h3>

                        {location.state?.pdfFile ? (
                            <div className="pdf-block">
                                {/* <div className="hide-pdf"></div> */}
                                {/* <div className="hide-copy"></div> */}
                                <p className="preview-material-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ac a, porttitor ac arcu morbi bibendum interdum non. Nisi etiam posuere orci lacus neque Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ac a, porttitor ac arcu morbi bibendum interdum non. Nisi etiam posuere orci lacus neque Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ac a, porttitor ac arcu morbi bibendum interdum non. Nisi etiam posuere orci lacus neque Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ac a, porttitor ac arcu morbi bibendum interdum non. Nisi etiam posuere orci lacus neque Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ac a, porttitor ac arcu morbi bibendum interdum non. Nisi etiam posuere orci lacus neque </p>
                                {/* <iframe style={{ userSelect: 'none' }}
                                    className="preview-material-desc"
                                    src={URL.createObjectURL(location.state.pdfFile)}

                                    title="PDF Document"
                                /> */}
                            </div>
                        ) : (
                            <p>PDF yuklanmagan</p>
                        )}

                        <div className="pdf-down">
                            <p className="pdf-down-title">Fayl yuklab olish</p>
                            <button className="con-pdfbtn"><i className="ri-folder-fill"></i> Audit.pdf</button>
                        </div>
                    </div>
                </div>
            </div>

            {
                !isConfirm ? (
                    <div className="preview-text">
                        <div className="preview-text-edit">
                            <p className="add-file-title">Matn yozish</p>
                            <textarea
                                required
                                placeholder='Your text here'
                                className="textarea"
                            />
                        </div>
                        <div className="add-text-right">
                            <button type='reset' className="cancel-btn">Cancel</button>
                            <button onClick={handleCon} className="fonfirm-btn">Confirm</button>
                        </div>
                    </div>
                ) : (
                    <div className="preview-text preview-true">
                        <div className="preview-text-edit">

                        </div>
                        <div className="add-text-right">
                            <button onClick={editHandle} type='reset' className="cancel-btn">Tahrirlash</button>
                            <button className="fonfirm-btn">Confirm</button>
                        </div>
                    </div>
                )
            }

            {
                editModal && (
                    <div className="edit-modal">
                        <div className="edit-modal-content">
                            <h3 className="edit-modal-title">Xato haqida izoh qoldiring?</h3>
                            <p className="add-file-title">Matn yozish</p>
                            <textarea placeholder='Your text here' className='edit-modal-textarea' id=""></textarea>
                            <div className="preview-text preview-true">
                                <div className="preview-text-edit">
                                </div>
                                <div className="edit-modal-btn">
                                    <button onClick={editHandle} type='reset' className="cancel-btn edit-cancel">Cancel</button>
                                    <button className="fonfirm-btn">Confirm</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </div>
    );
};

export default LessonPreview;
